// extracted by css-extract-rspack-plugin
export default {"button":"BevC8f","icon":"RDMhGL"};